<template>
    <div class="devices-list__block" v-if="deviceData" @click="openMotionHistory">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
            <div class="btn-group">
                <v-flex class="btn-block" @click.stop.prevent>
                    <device-switch-disabled :device-state="deviceData.state" :name="deviceData.uid"></device-switch-disabled>
                </v-flex>
            </div>
        </v-layout>
        <device-sensor-time v-if="deviceData.state" :time="deviceData.state.last_occupancy"></device-sensor-time>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
        <ModalMotionHistory v-model="openModal" :history="history"></ModalMotionHistory>
    </div>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";
import ModalMotionHistory from "@/components/modals/ModalMotionHistory";

export default {
    name: "MotionSensorDevice",
    components: {ModalWaiting, ModalMotionHistory},
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            history: [],
            openModal: false,
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openMotionHistory() {
            if (this.deviceData && this.deviceData.uid) {
                this.$refs.modalWaiting.open();
                this.$http.get('/devices/hotel-admin/motion-history/' + this.deviceData.uid + '/')
                    .then((response) => {
                        this.history = response.data.actions;
                        this.openModal = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$refs.modalWaiting.close();
                    });
            }
        },
    },
}
</script>